<template>
    <div>
        <swb-query-sort-area class="mb10" :config="queryConfig" :queryHandler="queryHandler"></swb-query-sort-area>

        <el-button type="primary" v-if="showAddFlag" @click="doRelGoodsCat()">关联商品分类</el-button>
        <div class="table-layout mt10">
            <el-table :data="goodsCatDevcGroups" border>
                <el-table-column prop="catName" label="分类名称" align="left"></el-table-column>
                <el-table-column prop="catLevel" label="分类等级" align="center">
                    <template slot-scope="rows">
                        <span>{{ rows.row.catLevel == 3 ? '三级' : '' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="关联时间" align="center"></el-table-column>
                <el-table-column label="操作" align="left">
                    <template slot-scope="rows">
                        <span class="swb-btn swb-btn-link" v-if="showAddFlag" @click="removeDo(rows.row.id)">移除</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="block pagination-layout">
            <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>

<script>
import { Utils } from '../../app.base'
import { Vue, MsgBox, Routes } from '../../app.vues'
import { getDefaultPageSizes } from '../../app.conf'
import { openCategAndDevcCatTreeMultiSelectDlg } from './selectDlg'
//
import goodsCategApi from '../../api/goodsCateg'

let searchConfigData = {
    'queryFields': [{
        'type': 'Text',
        'label': '分类名称',
        'code': 'catName',
        'basic': true,
        'valueType': 'String'
    }],
    'sortFields': []
};
//
export default {
    name: 'swb-goods-cat-devc-group-list',
    desc: '商品分类设备分组列表',
    avlScopes: 'retailer',
    props: ['groupId', 'groupName', 'showAddFlag'],
    data: function () {
        return {
            totalCount: 0,
            pageSize: null,
            pageSizes: getDefaultPageSizes(),
            pageNumber: 1,
            //排序、搜索
            queryConfig: null,
            queryModel: {
                filterItems: {},
                sortItemList: [],
                sortItems: {},
            },
            //
            goodsCatDevcGroups: [],
        }
    },
    created: function () {
        this.pageSize = this.pageSizes.first();
        this.queryConfig = searchConfigData || {};
        //
        if(!Utils.isNoB(this.groupId)) {
            this.getGoodsCatDevcGroups();
        }
    },
    methods: {
        queryHandler(queryModel) {
            //1、接收查询条件
            this.queryModel = queryModel;
            this.pageNumber = 1;
            //缓存查询条件
            this.getGoodsCatDevcGroups();
        },
        handleSizeChange: function (val) {
            let curStartIndex = (this.pageNumber - 1) * this.pageSize;
            this.pageSize = val;
            let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
            this.handlePageChange(newPageNumber);
        },
        handlePageChange: function (val) {
            this.pageNumber = val;
            this.getGoodsCatDevcGroups();
        },
        getGoodsCatDevcGroups: function () {
            let self = this;
            let postData = {};
            //
            postData.pagination = {
                pageSize: self.pageSize,
                pageNumber: self.pageNumber,
            };
            //
            let queryModel = self.queryModel;
            let filterItems = Utils.merge({}, queryModel.filterItems);
            let sortItemList = Utils.merge([], queryModel.sortItemList);
            let sortItems = Utils.merge({}, queryModel.sortItems);
            //
            if(!Utils.isNoB(self.groupId)) {
                filterItems.groupId = self.groupId;
            }
            //
            postData.filterItems = filterItems;
            postData.sortItemList = sortItemList;
            postData.sortItems = sortItems;
            //
            let theLoad = MsgBox.loading();
            goodsCategApi.getGoodsCatDevcGroupPageList(postData, function (result) {
                theLoad.hide();
                if(result.type === 'info') {
                    self.goodsCatDevcGroups = result.data.rows;
                    self.totalCount = result.data.pagination.totalCount;
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 关联商品分类
        doRelGoodsCat: function () {
            let self = this;
            let name = this.groupName;
            let id = this.groupId;
            let params = {
                filterItems: {
                    groupId: id
                }
            };
            goodsCategApi.getGoodsCatDevcGroupList(params, function (result) {
                if(result.type === 'info') {
                    let goodsCatDevcGroups = result.data || [];
                    let params = {};
                    // openCategTreeMultiSelectDlgTwo(params, goodsCatDevcGroups, function (resultData) {
                    openCategAndDevcCatTreeMultiSelectDlg(params, goodsCatDevcGroups, function (resultData) {
                        let postData = {
                            groupId: id,
                            groupName: name,
                            goodsCatDevcGroups: resultData.data
                        };
                        self.doSaveGoodsCatDevcGroups(postData);
                    });
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 保批量保存商品分类设备分组
        doSaveGoodsCatDevcGroups: function (postData) {
            let self = this;
            let theLoad = MsgBox.loading();
            goodsCategApi.saveGoodsCatDevcGroupBatch(postData, function (result) {
                theLoad.hide();
                if(result.type === 'info') {
                    self.getGoodsCatDevcGroups();
                    MsgBox.success('关联成功');
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 移除
        removeDo: function (id) {
            let self = this;
            self.$confirm('确定要移除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                let theLoad = MsgBox.loading();
                goodsCategApi.deleteGoodsCatDevcGroupBatch({id: id}, function (result) {
                    theLoad.hide();
                    if(result.type === 'info') {
                        Toast.show('操作成功');
                        //
                        self.getGoodsCatDevcGroups();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }).catch(function () {
            });
        }
    }
}

</script>



// WEBPACK FOOTER //
// src/compo/categ/GoodsCatDevcGroupList.vue